//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import FortuneWheel from '../../../components/-fortuneWheel';
import Badges from './badges.vue';

export default {
  components: { FortuneWheel, Badges },
  data() {
    return {};
  },
  computed: {
    ...mapGetters('sale', ['isCompanyCatalog']),
    isFortuneWheel() {
      return this.$store.getters['sale/isFortuneWheel'](this);
    },
    dateDuration() {
      const capitalizeFirstLetter = (string) =>
        string.charAt(0).toUpperCase() + string.slice(1);

      const startDate = this.$dayjs(
        this.$store.state?.sale?.sale?.startDate,
      ).locale(this.$i18n.locale);
      const endDate = this.$dayjs(
        this.$store.state?.sale?.sale?.endDate,
      ).locale(this.$i18n.locale);

      if (this.isCompanyCatalog) {
        return `
          ${capitalizeFirstLetter(startDate.format('MMMM'))} ${startDate.format(
          'DD, YYYY',
        )} -
          ${capitalizeFirstLetter(endDate.format('MMMM'))} ${endDate.format(
          'DD, YYYY',
        )}
        `;
      }

      if (endDate.diff(startDate, 'year') > 0) {
        return `
          ${capitalizeFirstLetter(startDate.format('MMMM'))} ${startDate.format(
          'DD',
        )} -
          ${capitalizeFirstLetter(endDate.format('MMMM'))} ${endDate.format(
          'DD, YYYY',
        )}
        `;
      }

      return `
        ${capitalizeFirstLetter(startDate.format('MMMM'))} ${startDate.format(
        'DD',
      )} -
        ${capitalizeFirstLetter(endDate.format('MMMM'))} ${endDate.format('DD')}
      `;
    },
    titleColor() {
      const sale = this.$store.state.sale.sale;
      if (sale.titleColor) return `#${sale.titleColor}`;
      return '#000000;';
    },
  },
  methods: {
    buildSrcSet(image) {
      const name1 = `${image}File`;
      const name2 = `${image}X2File`;
      const url1 = this.$store.state.sale.sale[name1]?.url;
      const url2 = this.$store.state.sale.sale[name2]?.url;

      const set1 = url1 ? `${url1} 1x` : null;
      const set2 = url2 ? `${url2} 2x` : null;

      return [set1, set2].filter((i) => i).join(', ');
    },
  },
};
